import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ROLES = ["Admin", "Commercial", "Viewer"];

export const InviteMemberDialog = ({ open, onOpenChange, email, role, onEmailChange, onRoleChange, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-2xl">
      <DialogHeader><DialogTitle>Inviter un commercial</DialogTitle></DialogHeader>
      <div className="space-y-3 mt-2">
        <div>
          <Label>Email</Label>
          <Input type="email" value={email} onChange={(e) => onEmailChange(e.target.value)} className="rounded-xl mt-1" data-testid="invite-email" placeholder="commercial@entreprise.fr" />
        </div>
        <div>
          <Label>Rôle</Label>
          <Select value={role} onValueChange={onRoleChange}>
            <SelectTrigger className="rounded-xl mt-1" data-testid="invite-role"><SelectValue /></SelectTrigger>
            <SelectContent>
              {ROLES.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <Button onClick={onSubmit} className="w-full rounded-full bg-emerald-500/100 hover:bg-emerald-500" data-testid="send-invite">Envoyer l'invitation</Button>
      </div>
    </DialogContent>
  </Dialog>
);
